import {useMemo} from 'react';

import {useIsSingleRun} from '../MultiRunWorkspace/SingleRunMode';

// if chart height is smaller than this hide the legend by default
export const MIN_SHOW_LEGEND_CHART_HEIGHT = 235;
export const MIN_SHOW_LEGEND_CHART_WIDTH = 250;

export function useLegendVisibility(
  showLegend: boolean | undefined,
  isMultiMetric?: boolean,
  panelSize?: {
    height: number;
    width: number;
  }
) {
  const isSingleRun = useIsSingleRun();
  return useMemo(
    () => getIsLegendShown({isSingleRun, isMultiMetric, showLegend, panelSize}),
    [isSingleRun, isMultiMetric, panelSize, showLegend]
  );
}

type GetIsLegendShownArgs = {
  showLegend: boolean | undefined;
  isSingleRun: boolean;
  isMultiMetric?: boolean;
  panelSize?: {
    height: number;
    width: number;
  };
};
export const getIsLegendShown = ({
  showLegend,
  isSingleRun,
  isMultiMetric,
  panelSize,
}: GetIsLegendShownArgs) => {
  // hide legends when the panel is too small to show them
  if (panelSize != null) {
    const {height, width} = panelSize;
    if (
      height <= MIN_SHOW_LEGEND_CHART_HEIGHT ||
      width <= MIN_SHOW_LEGEND_CHART_WIDTH
    ) {
      return false;
    }
  }

  // if showLegend is explicitly set, use that value
  if (typeof showLegend === 'boolean') {
    return showLegend;
  }

  // hide legends in single-run mode, single-metric plots
  if (isSingleRun && !isMultiMetric) {
    return false;
  }

  // otherwise, show legend
  return true;
};
